const getEntities = (list, addToList) => {
	list.forEach((item) => {
		if (item?.isEnabled) addToList([item]);
		if (item?.nodes?.length > 0) getEntities(item.nodes, addToList);
	});
};

const mapEntities = ({label, id, entityLevel, entityId = null}) => ({
	label,
	entityLevel,
	value: entityId ? entityId : id,
	id: entityId ? entityId : id,
	selected: false,
	disabled: false
});

export default (list, mapped = true) => {
	const newList = [];
	const addToList = (list) => newList.push(...list);
	getEntities(list, addToList);
	return mapped ? newList.map(mapEntities) : newList;
};
